import "./LegalTax.scss";
import {
  LegalIcon,
  DashboardIcon,
  CheckCircleIcon,
  AlertIcon,
  FileTextIcon,
} from "../../../../../shared/cockpit/components/icons/Icon";

export default function LegalTax() {
  return (
    <div className="legal-tax-view">
      <div className="legal-tax-view__header">
        <h1 className="legal-tax-view__title">Legal & Compliance</h1>
        <p className="legal-tax-view__subtitle">
          Rechtssicherheit, Steuern & Mieterstrom
        </p>
      </div>

      <div className="legal-tax-view__grid">
        {/* Erster Container: Gewerbesteuerkürzung */}
        <div className="legal-card">
          <div className="legal-card__header">
            <div className="legal-card__icon-wrapper legal-card__icon-wrapper--red">
              <LegalIcon />
            </div>
            <div className="legal-card__title-group">
              <h3>Erweiterte Gewerbesteuerkürzung (§ 9 GewStG)</h3>
              <p>
                Schutz der steuerlichen Privilegien der Besitzgesellschaften
              </p>
            </div>
          </div>

          <div className="legal-card__content">
            <div className="status-box status-box--success">
              <div className="status-box__header">
                <CheckCircleIcon className="status-box__icon" />
                <h4>Trennung Besitz/Betrieb</h4>
              </div>
              <p>
                Alle PV-Anlagen und Wallboxen werden sauber über die{" "}
                <strong>Schmidt Energie GmbH (Betreiber)</strong> abgewickelt.
                Keine schädlichen Tätigkeiten in den Immobilien-KGs.
              </p>
            </div>

            <div className="status-box status-box--warning">
              <div className="status-box__header">
                <AlertIcon className="status-box__icon" />
                <h4>Warnung: Standort "Musterstraße 12"</h4>
              </div>
              <p>
                Hier wurde eine Wallbox direkt auf die Immobilien-KG bestellt.
                <br />
                <strong>Handlung:</strong> Rechnung muss auf Schmidt Energie
                GmbH umgeschrieben werden.
              </p>
              <button className="btn-correction">Korrektur anfordern</button>
            </div>
          </div>
        </div>

        {/* Zweiter Container: Mieterstrom */}
        <div className="legal-card">
          <div className="legal-card__header">
            <div className="legal-card__icon-wrapper legal-card__icon-wrapper--blue">
              <DashboardIcon />
            </div>
            <div className="legal-card__title-group">
              <h3>Mieterstrom & Abrechnung</h3>
              <p>Virtuelle Summenzähler & Metergrid-Integration</p>
            </div>
          </div>

          <div className="legal-card__content">
            <div className="project-item">
              <div className="project-item__info">
                <h4>CaOs Wohnen Essen</h4>
                <span>12 Wohneinheiten</span>
              </div>
              <span className="badge badge--active">Aktiv</span>
            </div>

            <div className="project-item">
              <div className="project-item__info">
                <h4>Neubauprojekt "Hafenquartier"</h4>
                <span>45 Wohneinheiten + Bewerbe</span>
              </div>
              <span className="badge badge--planning">In Planung</span>
            </div>

            <div className="documents-section">
              <h5>DOKUMENTE</h5>
              <div className="doc-list">
                <div className="doc-item">
                  <FileTextIcon />
                  <span>Muster-Mieterstromvertrag.pdf</span>
                </div>
                <div className="doc-item">
                  <FileTextIcon />
                  <span>Messkonzept_MK_B3.pdf</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
